<template>
  <div>
    <ListItemFilters
      icon="ui-icon-doctor"
      :title="lpuFiltersState.doctorSpeciality?.name || t('Специальность врача', options)"
      :subtitle="lpuFiltersState.doctorSpeciality ? t('Специальность врача', options) : ''"
      @click="openDialog"
    />

    <DoctorSpecialityModal
      :value="isDialogOpened"
      is-back
      @speciality:selected="onClickDoctorSpeciality"
      @input="handleCloseDoctorSpecialityModal"
    >
      <template #footer="{ selectedSpeciality }">
        <div class="pa-2 elevation-8">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedDoctorSpeciality"
            @click="handleDoctorSpecialitySelected(selectedSpeciality)"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </template>
    </DoctorSpecialityModal>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import deepEqual from 'www/vue_components/common/TheFilters/lpu/functions/deepEqual'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import DoctorSpecialityModal from 'www/vue_components/common/TheFilters/lpu/components/DoctorSpecialityFilters/components/DoctorSpecialityModal.vue'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: lpuFiltersState } = toRefs(props)
const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemDoctorSpeciality')

const hasUnsavedDoctorSpeciality = computed(() => (
  !deepEqual(lpuFiltersState.value.doctorSpeciality, filtersStore.unsavedFilters.doctorSpeciality)
))

const handleCloseDoctorSpecialityModal = () => {
  closeDialog()
  filtersStore.updateUnsavedFilters(lpuFiltersState.value)
}

const onClickDoctorSpeciality = (doctorSpeciality: Filters['doctorSpeciality']) => {
  filtersStore.updateUnsavedFilters({ doctorSpeciality })
}

const handleDoctorSpecialitySelected = (doctorSpeciality: Filters['doctorSpeciality']) => {
  closeDialog()

  filtersStore.updateUnsavedFilters({ doctorSpeciality })
  emit('input', filtersStore.unsavedFilters)
}
</script>
